import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-get-time-dialog',
  templateUrl: './get-time-dialog.component.html',
  styleUrls: ['./get-time-dialog.component.css']
})

export class GetTimeDialogComponent {

  message: string = "";
  confirmButtonText = "Confirmar Orden";
  cancelButtonText = "Cancelar";

  timeValue: number = 30;

  timesList = [
    30,
    45,
    60,
    75,
    90
  ]

  getOrderTimeForm: FormGroup = this.fb.group({
    timeValue: [30, Validators.required]
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: any,
    private dialogRef: MatDialogRef<GetTimeDialogComponent>,
    private fb: FormBuilder
  )
  {
    if (data)
      this.message = data.message || this.message;
  }

  onConfirmClick(): void {
    this.dialogRef.close(this.getOrderTimeForm.controls['timeValue'].value);
  }
}
